// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Iqpn9","fullView":"styles_fullView__3YmMx"};